<template>
  <div v-loading="loaderShipping" class="shipping__national">
    <h4
      class="shipping-title"
      :class="darkMode ? 'darktxtswiper' : 'lighttxtswiper'"
    >
      {{ $t("text_envios") }}
      <sliderInformation :actions="true" url="https://ayuda.komercia.co/komercia/article/Empresa/582/Configura%20la%20opci%C3%B3n%20de%20env%C3%ADo%20/23/7" class="ml-2" />
    </h4>
    <p v-if="storeData && storeData.tipo_inventario == 1" class="wrapper-nota">
      <strong>Nota:</strong> Los medios de envió solo están disponibles para
      productos propios, dropshipping usa medios de transporte propio
    </p>
    <div class="w-full flex flex-row justify-between items-center">
      <p class="shipping-subtitle" :class="darkMode ? 'darktxt' : 'lighttxt'">
        {{ $t("text_envios_info") }}
      </p>
      <div>
        <p
          v-if="!toggleSwipper"
          :class="darkMode ? 'darktxtswiper' : 'lighttxtswiper'"
          class="policies"
          @click="next"
        >
          {{ $t("text_envios_politicasEnvios") }}
          <i class="el-icon-arrow-right" />
        </p>
        <p v-else class="methods" @click="prev">
          <i class="el-icon-arrow-left" />
          {{ $t("text_envios_metodosEnvio") }}
        </p>
      </div>
    </div>

    <div class="row">
      <swiper ref="mySwiper" :options="swiperOption">
        <swiper-slide class="slide-1">
          <!-- <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 centered column"> -->
          <div class="w-full">
            <el-radio-group v-model="choice">
              <el-radio-button class="w-auto mr-4" label="gratis">
                <svg
                  id="Capa_1"
                  data-name="Capa 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 68.52 68.65"
                  width="73.403"
                  height="74.802"
                >
                  <path
                    class="cls-1"
                    d="M9.77,68.15a1.79,1.79,0,0,1-.93-1.78c0-6,0-11.89,0-17.84v-.84H2.47A1.36,1.36,0,0,1,1.16,47a1.32,1.32,0,0,1,.15-1.47L9,34a1.47,1.47,0,0,1,1.32-.7H41.93a1.32,1.32,0,1,1,0,2.61H37c.12.21.19.36.28.5,1.82,2.74,3.64,5.49,5.49,8.22a1,1,0,0,0,.69.44q10.24,0,20.48,0l.24,0c-.09-.17-.17-.32-.26-.46q-2.73-4.11-5.47-8.23a.85.85,0,0,0-.84-.45c-1.18,0-2.36,0-3.53,0a1.33,1.33,0,0,1-1.51-1.28c0-.8.58-1.33,1.52-1.34,1.46,0,2.92,0,4.39,0a1.77,1.77,0,0,1,1.67.91Q64.08,40.09,68,46v.79a1.73,1.73,0,0,1-1.78.93c-1.8,0-3.61,0-5.42,0l-.65,0v.84c0,5.94,0,11.87,0,17.81a1.81,1.81,0,0,1-.93,1.78Zm1.74-20.46V65.48H33.16V39l-.48.68c-1.57,2.36-3.16,4.72-4.71,7.09a1.83,1.83,0,0,1-1.73.92c-4.67,0-9.34,0-14,0Zm46,0h-.76c-4.65,0-9.29,0-13.94,0a1.92,1.92,0,0,1-1.82-1c-1.53-2.36-3.11-4.7-4.67-7L35.87,39V65.49H57.52ZM4.77,45l.44,0c6.76,0,13.52,0,20.28,0a.83.83,0,0,0,.77-.46l5.47-8.24c.09-.13.16-.28.28-.49h-.79c-6.3,0-12.6,0-18.91,0A2.3,2.3,0,0,0,10,37.08C8.36,39.74,6.58,42.33,4.77,45Z"
                  />
                  <path
                    class="cls-1"
                    d="M33.46,2c.44.12.89.21,1.32.35A7.56,7.56,0,0,1,39,12.77a12.52,12.52,0,0,1-3.11,4.09c-2.76,2.41-5.58,4.74-8.39,7.1A1.18,1.18,0,0,1,25.9,24c-3.31-2.77-6.86-5.26-9.76-8.5a8.87,8.87,0,0,1-2.57-6.32,7.25,7.25,0,0,1,6-7.11,1,1,0,0,0,.24-.1h1.83A7.28,7.28,0,0,1,26.1,4.55l.52.64c2.47-2.72,3.07-2.65,5-3.19ZM26.57,21.4c2.35-2,4.54-3.77,6.67-5.64a21,21,0,0,0,2.43-2.56,5.81,5.81,0,0,0,1.45-4A4.7,4.7,0,0,0,33.84,4.8a4.33,4.33,0,0,0-5,1.94,10.52,10.52,0,0,0-.92,1.8,1.34,1.34,0,0,1-1.31,1,1.39,1.39,0,0,1-1.26-1A15.71,15.71,0,0,0,24.1,6.28a3.91,3.91,0,0,0-2.36-1.54,4.66,4.66,0,0,0-5.5,5.46A6.72,6.72,0,0,0,18.31,14C21,16.49,23.78,18.91,26.57,21.4Z"
                  />
                  <path
                    class="cls-1"
                    d="M48.16,16.84A5.31,5.31,0,0,1,51,15a5.22,5.22,0,0,1,6.25,4.23,6.28,6.28,0,0,1-1.34,5.28,18.55,18.55,0,0,1-2.13,2.3c-1.49,1.38-3,2.69-4.57,4a1.28,1.28,0,0,1-1.89.08c-1.84-1.61-3.69-3.2-5.47-4.87a8.2,8.2,0,0,1-2.74-4.72,5.46,5.46,0,0,1,5.36-6.44,4.73,4.73,0,0,1,3.27,1.44A4.79,4.79,0,0,1,48.16,16.84Zm0,11.41c1.15-1,2.19-1.83,3.15-2.73s1.75-1.71,2.55-2.63a3.66,3.66,0,0,0,.92-2.66,2.83,2.83,0,0,0-2.08-2.71,2.55,2.55,0,0,0-2.85,1.59,7,7,0,0,0-.35.84,1.3,1.3,0,0,1-1.27.94,1.32,1.32,0,0,1-1.27-1,7.35,7.35,0,0,0-.49-1.07,2.42,2.42,0,0,0-2.53-1.37,2.61,2.61,0,0,0-2.13,2.12,3.71,3.71,0,0,0,1.1,3.65C44.57,25,46.35,26.57,48.14,28.25Z"
                  />
                  <path
                    class="cls-1"
                    d="M49.3,34.6a1.31,1.31,0,1,1-1.25-1.33A1.33,1.33,0,0,1,49.3,34.6Z"
                  />
                  <path
                    class="cls-2"
                    d="M8.77,66.15a1.79,1.79,0,0,1-.93-1.78c0-6,0-11.89,0-17.84v-.84H1.47A1.36,1.36,0,0,1,.16,45a1.32,1.32,0,0,1,.15-1.47L8,32a1.47,1.47,0,0,1,1.32-.7H40.93a1.32,1.32,0,1,1,0,2.61H36c.12.21.19.36.28.5,1.82,2.74,3.64,5.49,5.49,8.22a1,1,0,0,0,.69.44q10.24,0,20.48,0l.24,0c-.09-.17-.17-.32-.26-.46q-2.73-4.11-5.47-8.23a.85.85,0,0,0-.84-.45c-1.18,0-2.36,0-3.53,0a1.33,1.33,0,0,1-1.51-1.28c0-.8.58-1.33,1.52-1.34,1.46,0,2.92,0,4.39,0a1.77,1.77,0,0,1,1.67.91Q63.08,38.09,67,44v.79a1.73,1.73,0,0,1-1.78.93c-1.8,0-3.61,0-5.42,0l-.65,0v.84c0,5.94,0,11.87,0,17.81a1.81,1.81,0,0,1-.93,1.78Zm1.74-20.46V63.48H32.16V37l-.48.68c-1.57,2.36-3.16,4.72-4.71,7.09a1.83,1.83,0,0,1-1.73.92c-4.67,0-9.34,0-14,0Zm46,0h-.76c-4.65,0-9.29,0-13.94,0a1.92,1.92,0,0,1-1.82-1c-1.53-2.36-3.11-4.7-4.67-7L34.87,37V63.49H56.52ZM3.77,43l.44,0c6.76,0,13.52,0,20.28,0a.83.83,0,0,0,.77-.46l5.47-8.24c.09-.13.16-.28.28-.49h-.79c-6.3,0-12.6,0-18.91,0A2.3,2.3,0,0,0,9,35.08C7.36,37.74,5.58,40.33,3.77,43Z"
                  />
                  <path
                    class="cls-2"
                    d="M32.46,0c.44.12.89.21,1.32.35A7.56,7.56,0,0,1,38,10.77a12.52,12.52,0,0,1-3.11,4.09c-2.76,2.41-5.58,4.74-8.39,7.1A1.18,1.18,0,0,1,24.9,22c-3.31-2.77-6.86-5.26-9.76-8.5a8.87,8.87,0,0,1-2.57-6.32,7.25,7.25,0,0,1,6-7.11,1,1,0,0,0,.24-.1h1.83A7.28,7.28,0,0,1,25.1,2.55l.52.64C28.09.47,28.69.54,30.63,0ZM25.57,19.4c2.35-2,4.54-3.77,6.67-5.64a21,21,0,0,0,2.43-2.56,5.81,5.81,0,0,0,1.45-4A4.7,4.7,0,0,0,32.84,2.8a4.33,4.33,0,0,0-5,1.94,10.52,10.52,0,0,0-.92,1.8,1.34,1.34,0,0,1-1.31,1,1.39,1.39,0,0,1-1.26-1A15.71,15.71,0,0,0,23.1,4.28a3.91,3.91,0,0,0-2.36-1.54,4.66,4.66,0,0,0-5.5,5.46A6.72,6.72,0,0,0,17.31,12C20,14.49,22.78,16.91,25.57,19.4Z"
                  />
                  <path
                    class="cls-2"
                    d="M47.16,14.84A5.31,5.31,0,0,1,50,13a5.22,5.22,0,0,1,6.25,4.23,6.28,6.28,0,0,1-1.34,5.28,18.55,18.55,0,0,1-2.13,2.3c-1.49,1.38-3,2.69-4.57,4a1.28,1.28,0,0,1-1.89.08c-1.84-1.61-3.69-3.2-5.47-4.87a8.2,8.2,0,0,1-2.74-4.72,5.46,5.46,0,0,1,5.36-6.44,4.73,4.73,0,0,1,3.27,1.44A4.79,4.79,0,0,1,47.16,14.84Zm0,11.41c1.15-1,2.19-1.83,3.15-2.73s1.75-1.71,2.55-2.63a3.66,3.66,0,0,0,.92-2.66,2.83,2.83,0,0,0-2.08-2.71,2.55,2.55,0,0,0-2.85,1.59,7,7,0,0,0-.35.84,1.3,1.3,0,0,1-1.27.94,1.32,1.32,0,0,1-1.27-1,7.35,7.35,0,0,0-.49-1.07,2.42,2.42,0,0,0-2.53-1.37,2.61,2.61,0,0,0-2.13,2.12,3.71,3.71,0,0,0,1.1,3.65C43.57,23,45.35,24.57,47.14,26.25Z"
                  />
                  <path
                    class="cls-2"
                    d="M48.3,32.6a1.31,1.31,0,1,1-1.25-1.33A1.33,1.33,0,0,1,48.3,32.6Z"
                  />
                </svg>
                <p class="mt-2">{{ $t("text_envios_enviosGratis") }}</p>
              </el-radio-button>
              <el-radio-button class="w-auto mr-4" label="tarifa_plana">
                <!--  <img loading="lazy"
                  src="../../../assets/tarif-plana.png"
                  :class="choice === 'tarifa_plana' ? 'shadow' : ''"
                /> -->
                <svg
                  class="ml-2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="73.403"
                  height="74.802"
                  viewBox="0 0 73.403 74.802"
                >
                  <g
                    id="Grupo_706"
                    data-name="Grupo 706"
                    transform="translate(586.993 -20)"
                  >
                    <g
                      id="Grupo_697"
                      data-name="Grupo 697"
                      transform="translate(-585.596 22.793)"
                    >
                      <g
                        id="Grupo_692"
                        data-name="Grupo 692"
                        transform="translate(9.497 63.128)"
                      >
                        <g id="Grupo_691" data-name="Grupo 691">
                          <path
                            id="Trazado_24"
                            d="M-506.614 492.41a1.406 1.406 0 0 0-.986-.41 1.407 1.407 0 0 0-.987.409 1.407 1.407 0 0 0-.409.987 1.406 1.406 0 0 0 .409.987 1.407 1.407 0 0 0 .987.409 1.406 1.406 0 0 0 .987-.409 1.407 1.407 0 0 0 .409-.987 1.407 1.407 0 0 0-.41-.986z"
                            class="cls-1"
                            data-name="Trazado 24"
                            transform="translate(508.998 -492.001)"
                          />
                        </g>
                      </g>
                      <g
                        id="Grupo_694"
                        data-name="Grupo 694"
                        transform="translate(63.191 25.141)"
                      >
                        <g id="Grupo_693" data-name="Grupo 693">
                          <path
                            id="Trazado_25"
                            d="M-122.163 220.417a1.4 1.4 0 0 0-.987-.409 1.407 1.407 0 0 0-.987.409 1.408 1.408 0 0 0-.409.987 1.407 1.407 0 0 0 .409.987 1.407 1.407 0 0 0 .987.409 1.4 1.4 0 0 0 .987-.409 1.4 1.4 0 0 0 .41-.987 1.4 1.4 0 0 0-.41-.987z"
                            class="cls-1"
                            data-name="Trazado 25"
                            transform="translate(124.547 -220.008)"
                          />
                        </g>
                      </g>
                      <g id="Grupo_696" data-name="Grupo 696">
                        <g id="Grupo_695" data-name="Grupo 695">
                          <path
                            id="Trazado_26"
                            d="M-505.9 40.409a1.4 1.4 0 0 0-.988-.409h-34.357a1.4 1.4 0 0 0-1.4 1.4v3.994l-13.239 3.547a1.4 1.4 0 0 0-.988 1.71L-550 76.257l-5.936 5.936a4.188 4.188 0 0 0-3.459-1.828H-572.8a4.2 4.2 0 0 0-4.19 4.19v22.765a4.2 4.2 0 0 0 4.19 4.19h13.4a4.2 4.2 0 0 0 4.066-3.182l1.661 1.448a7.036 7.036 0 0 0 4.625 1.733h42.16a1.4 1.4 0 0 0 1.4-1.4V41.4a1.4 1.4 0 0 0-.412-.991zm-52.1 66.909a1.4 1.4 0 0 1-1.4 1.4h-13.4a1.4 1.4 0 0 1-1.4-1.4V84.554a1.4 1.4 0 0 1 1.4-1.4h5.307v16.092a1.4 1.4 0 0 0 1.4 1.4 1.4 1.4 0 0 0 1.4-1.4V83.157h5.307a1.4 1.4 0 0 1 1.4 1.4v22.765zm4.2-56.042l11.167-2.992v5.175l-.936.251a1.4 1.4 0 0 0-.848.651 1.4 1.4 0 0 0-.14 1.06 3.765 3.765 0 0 1-2.659 4.606 1.4 1.4 0 0 0-.849.652 1.4 1.4 0 0 0-.138 1.061l5.444 20.159h-2.8l-1.445-5.651a1.394 1.394 0 0 0-.234-.49zm11.167 8.588v11.785l-2.547-9.432a6.543 6.543 0 0 0 2.542-2.353zm20.065 48.851h-26.472a4.244 4.244 0 0 1-2.79-1.045l-3.373-2.941V85.411l6.1-6.1 1.103 4.33a1.4 1.4 0 0 0 1.353 1.051h27.459a1.957 1.957 0 0 1 1.955 1.955 1.957 1.957 0 0 1-1.955 1.955h-14.07a1.4 1.4 0 0 0-1.4 1.4 1.4 1.4 0 0 0 1.4 1.4h18.441a1.957 1.957 0 0 1 1.955 1.955 1.957 1.957 0 0 1-1.955 1.955h-18.441a1.4 1.4 0 0 0-1.4 1.4 1.4 1.4 0 0 0 1.4 1.4h15.453a1.957 1.957 0 0 1 1.955 1.955 1.957 1.957 0 0 1-1.955 1.955h-15.453a1.4 1.4 0 0 0-1.4 1.4 1.4 1.4 0 0 0 1.4 1.4h10.689a1.957 1.957 0 0 1 1.955 1.955 1.957 1.957 0 0 1-1.959 1.938zm14.292 0h-9.966a4.72 4.72 0 0 0 .423-1.955 4.72 4.72 0 0 0-.423-1.955h.438a4.754 4.754 0 0 0 4.748-4.748 4.718 4.718 0 0 0-.5-2.125 4.756 4.756 0 0 0 3.492-4.578 4.723 4.723 0 0 0-.937-2.829v-17.7a1.4 1.4 0 0 0-1.4-1.4 1.4 1.4 0 0 0-1.4 1.4v15.89a4.75 4.75 0 0 0-1.018-.111h-.046a4.719 4.719 0 0 0 .423-1.955 4.754 4.754 0 0 0-4.748-4.748h-2.245a6.693 6.693 0 0 0 4.058-6.146 6.691 6.691 0 0 0-6.684-6.684 6.692 6.692 0 0 0-6.684 6.684 6.694 6.694 0 0 0 4.058 6.146h-7.634V55.344a6.574 6.574 0 0 0 5.007-5.007h10.506a6.575 6.575 0 0 0 5.007 5.007v4.342a1.4 1.4 0 0 0 1.4 1.4 1.4 1.4 0 0 0 1.4-1.4V54.1a1.4 1.4 0 0 0-1.4-1.4 3.765 3.765 0 0 1-3.76-3.76 1.4 1.4 0 0 0-1.4-1.4h-13a1.4 1.4 0 0 0-1.4 1.4 3.765 3.765 0 0 1-3.76 3.76 1.4 1.4 0 0 0-1.4 1.4v27.8h-2.728V42.795h31.563zm-15.782-29.07a3.9 3.9 0 0 1-3.891-3.891 3.9 3.9 0 0 1 3.891-3.891 3.9 3.9 0 0 1 3.891 3.891 3.9 3.9 0 0 1-3.896 3.891z"
                            class="cls-1"
                            data-name="Trazado 26"
                            transform="translate(576.994 -40)"
                          />
                        </g>
                      </g>
                    </g>
                    <g
                      id="Grupo_705"
                      data-name="Grupo 705"
                      transform="translate(-586.993 20)"
                    >
                      <g id="Grupo_704" data-name="Grupo 704">
                        <g
                          id="Grupo_699"
                          data-name="Grupo 699"
                          transform="translate(9.497 63.128)"
                        >
                          <g id="Grupo_698" data-name="Grupo 698">
                            <path
                              id="Trazado_27"
                              d="M-516.613 472.41a1.406 1.406 0 0 0-.987-.41 1.407 1.407 0 0 0-.987.409 1.407 1.407 0 0 0-.409.987 1.406 1.406 0 0 0 .409.987 1.407 1.407 0 0 0 .987.409 1.407 1.407 0 0 0 .987-.409 1.407 1.407 0 0 0 .409-.987 1.407 1.407 0 0 0-.409-.986z"
                              class="cls-2"
                              data-name="Trazado 27"
                              transform="translate(518.997 -472.001)"
                            />
                          </g>
                        </g>
                        <g
                          id="Grupo_701"
                          data-name="Grupo 701"
                          transform="translate(63.191 25.141)"
                        >
                          <g id="Grupo_700" data-name="Grupo 700">
                            <path
                              id="Trazado_28"
                              d="M-132.162 200.417a1.4 1.4 0 0 0-.987-.409 1.407 1.407 0 0 0-.987.409 1.408 1.408 0 0 0-.409.987 1.407 1.407 0 0 0 .409.987 1.407 1.407 0 0 0 .987.409 1.4 1.4 0 0 0 .987-.409 1.4 1.4 0 0 0 .41-.987 1.4 1.4 0 0 0-.41-.987z"
                              class="cls-2"
                              data-name="Trazado 28"
                              transform="translate(134.546 -200.008)"
                            />
                          </g>
                        </g>
                        <g id="Grupo_703" data-name="Grupo 703">
                          <g id="Grupo_702" data-name="Grupo 702">
                            <path
                              id="Trazado_29"
                              d="M-515.9 20.409a1.4 1.4 0 0 0-.988-.409h-34.357a1.4 1.4 0 0 0-1.4 1.4v3.994l-13.239 3.547a1.4 1.4 0 0 0-.988 1.71L-560 56.257l-5.936 5.936a4.188 4.188 0 0 0-3.459-1.828H-582.8a4.2 4.2 0 0 0-4.19 4.19v22.763a4.2 4.2 0 0 0 4.19 4.19h13.4a4.2 4.2 0 0 0 4.066-3.182l1.661 1.448a7.037 7.037 0 0 0 4.625 1.734h42.16a1.4 1.4 0 0 0 1.4-1.4V21.4a1.4 1.4 0 0 0-.412-.991zM-568 87.318a1.4 1.4 0 0 1-1.4 1.4h-13.4a1.4 1.4 0 0 1-1.4-1.4V64.554a1.4 1.4 0 0 1 1.4-1.4h5.307v16.092a1.4 1.4 0 0 0 1.4 1.4 1.4 1.4 0 0 0 1.4-1.4V63.157h5.307a1.4 1.4 0 0 1 1.4 1.4v22.761zm4.2-56.042l11.167-2.992v5.175l-.936.251a1.4 1.4 0 0 0-.848.651 1.4 1.4 0 0 0-.14 1.06 3.765 3.765 0 0 1-2.659 4.606 1.4 1.4 0 0 0-.849.652 1.4 1.4 0 0 0-.138 1.061l5.444 20.159h-2.8l-1.445-5.651a1.4 1.4 0 0 0-.234-.49zm11.167 8.588v11.785l-2.547-9.432a6.543 6.543 0 0 0 2.543-2.353zm20.065 48.851h-26.472a4.244 4.244 0 0 1-2.79-1.045l-3.373-2.941V65.411l6.1-6.1 1.103 4.33a1.4 1.4 0 0 0 1.353 1.051h27.459a1.958 1.958 0 0 1 1.955 1.955 1.958 1.958 0 0 1-1.955 1.955h-14.07a1.4 1.4 0 0 0-1.4 1.4 1.4 1.4 0 0 0 1.4 1.4h18.441a1.957 1.957 0 0 1 1.955 1.955 1.957 1.957 0 0 1-1.955 1.955h-18.441a1.4 1.4 0 0 0-1.4 1.4 1.4 1.4 0 0 0 1.4 1.4h15.453a1.957 1.957 0 0 1 1.955 1.955 1.957 1.957 0 0 1-1.955 1.955h-15.453a1.4 1.4 0 0 0-1.4 1.4 1.4 1.4 0 0 0 1.4 1.4h10.689a1.957 1.957 0 0 1 1.955 1.955 1.958 1.958 0 0 1-1.958 1.938zm14.292 0h-9.966a4.72 4.72 0 0 0 .423-1.955 4.72 4.72 0 0 0-.423-1.955h.438a4.754 4.754 0 0 0 4.748-4.748 4.718 4.718 0 0 0-.5-2.125 4.756 4.756 0 0 0 3.492-4.578 4.723 4.723 0 0 0-.937-2.829v-17.7a1.4 1.4 0 0 0-1.4-1.4 1.4 1.4 0 0 0-1.4 1.4v15.89a4.749 4.749 0 0 0-1.018-.111h-.046a4.719 4.719 0 0 0 .423-1.955 4.754 4.754 0 0 0-4.748-4.748h-2.245a6.693 6.693 0 0 0 4.058-6.146 6.692 6.692 0 0 0-6.684-6.684 6.692 6.692 0 0 0-6.684 6.684 6.694 6.694 0 0 0 4.058 6.146h-7.634V35.344a6.574 6.574 0 0 0 5.007-5.007h10.506a6.574 6.574 0 0 0 5.007 5.007v4.342a1.4 1.4 0 0 0 1.4 1.4 1.4 1.4 0 0 0 1.4-1.4V34.1a1.4 1.4 0 0 0-1.4-1.4 3.765 3.765 0 0 1-3.76-3.76 1.4 1.4 0 0 0-1.4-1.4h-13a1.4 1.4 0 0 0-1.4 1.4 3.765 3.765 0 0 1-3.76 3.76 1.4 1.4 0 0 0-1.4 1.4v27.8h-2.728V22.795h31.563zm-15.782-29.07a3.9 3.9 0 0 1-3.891-3.891 3.9 3.9 0 0 1 3.891-3.891 3.9 3.9 0 0 1 3.891 3.891 3.9 3.9 0 0 1-3.895 3.891z"
                              class="cls-2"
                              data-name="Trazado 29"
                              transform="translate(586.993 -20)"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
                <p class="mt-2">{{ $t("text_envios_tarifaPlana") }}</p>
              </el-radio-button>
              <el-radio-button class="w-auto mr-4" label="precio">
                <!--  <img loading="lazy"
                  src="../../../assets/precio.png"
                  :class="choice === 'precio' ? 'shadow' : ''"
                /> -->
                <svg
                  class="ml-2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="72.405"
                  height="72.751"
                  viewBox="0 0 72.405 72.751"
                >
                  <g
                    id="Grupo_709"
                    data-name="Grupo 709"
                    transform="translate(158.358 552.679)"
                  >
                    <g
                      id="Grupo_707"
                      data-name="Grupo 707"
                      transform="translate(-157.386 -551.362)"
                    >
                      <path
                        id="Trazado_30"
                        d="M-90.824-532.753a35.214 35.214 0 0 0-25.05-10.417 35.214 35.214 0 0 0-25.05 10.417A35.214 35.214 0 0 0-151.34-507.7a35.214 35.214 0 0 0 10.417 25.05 35.214 35.214 0 0 0 25.05 10.417 35.214 35.214 0 0 0 25.05-10.417 35.214 35.214 0 0 0 10.416-25.05 35.214 35.214 0 0 0-10.417-25.053zm-25.05 56.36a31.346 31.346 0 0 1-31.31-31.31 31.346 31.346 0 0 1 31.31-31.31 31.346 31.346 0 0 1 31.31 31.31 31.346 31.346 0 0 1-31.309 31.31z"
                        class="cls-1"
                        data-name="Trazado 30"
                        transform="translate(151.34 543.17)"
                      />
                      <path
                        id="Trazado_31"
                        d="M-63.324-482.17a27.046 27.046 0 0 0-27.016 27.016 27.046 27.046 0 0 0 27.016 27.016 27.046 27.046 0 0 0 27.016-27.016 27.046 27.046 0 0 0-27.016-27.016zm0 49.875a22.885 22.885 0 0 1-22.859-22.859 22.885 22.885 0 0 1 22.859-22.859 22.885 22.885 0 0 1 22.859 22.859A22.885 22.885 0 0 1-63.324-432.3z"
                        class="cls-1"
                        data-name="Trazado 31"
                        transform="translate(98.791 490.621)"
                      />
                      <path
                        id="Trazado_32"
                        d="M46.285-409.854a2.078 2.078 0 0 0 2.078 2.078 2.078 2.078 0 0 0 2.078-2.078 7.664 7.664 0 0 0-3.266-6.071A11.421 11.421 0 0 0 42.129-418v-2.244a2.078 2.078 0 0 0-2.078-2.078 2.078 2.078 0 0 0-2.078 2.078V-418a11.419 11.419 0 0 0-5.047 2.076 7.664 7.664 0 0 0-3.266 6.071 7.665 7.665 0 0 0 3.266 6.071 11.421 11.421 0 0 0 5.047 2.076v8.231c-2.394-.585-4.156-2.139-4.156-3.909a2.078 2.078 0 0 0-2.078-2.078 2.078 2.078 0 0 0-2.078 2.078 7.665 7.665 0 0 0 3.266 6.071 11.421 11.421 0 0 0 5.047 2.076v2.265a2.078 2.078 0 0 0 2.078 2.078 2.078 2.078 0 0 0 2.078-2.078v-2.265a11.419 11.419 0 0 0 5.046-2.076 7.664 7.664 0 0 0 3.266-6.071 7.664 7.664 0 0 0-3.266-6.071 11.421 11.421 0 0 0-5.046-2.076v-8.231c2.394.585 4.156 2.139 4.156 3.909zm-12.469 0c0-1.77 1.762-3.323 4.156-3.909v7.817c-2.394-.585-4.156-2.138-4.156-3.908zm12.469 12.469c0 1.77-1.762 3.323-4.156 3.909v-7.817c2.394.584 4.156 2.138 4.156 3.908z"
                        class="cls-1"
                        data-name="Trazado 32"
                        transform="translate(-4.584 439.065)"
                      />
                    </g>
                    <g
                      id="Grupo_708"
                      data-name="Grupo 708"
                      transform="translate(-158.358 -552.679)"
                    >
                      <path
                        id="Trazado_33"
                        d="M-97.842-542.262a35.214 35.214 0 0 0-25.05-10.417 35.214 35.214 0 0 0-25.05 10.417 35.214 35.214 0 0 0-10.417 25.05 35.214 35.214 0 0 0 10.417 25.05 35.214 35.214 0 0 0 25.05 10.417 35.214 35.214 0 0 0 25.05-10.417 35.214 35.214 0 0 0 10.417-25.05 35.214 35.214 0 0 0-10.417-25.05zm-25.05 56.36a31.346 31.346 0 0 1-31.31-31.31 31.346 31.346 0 0 1 31.31-31.31 31.346 31.346 0 0 1 31.31 31.31 31.346 31.346 0 0 1-31.309 31.312z"
                        class="cls-2"
                        data-name="Trazado 33"
                        transform="translate(158.358 552.679)"
                      />
                      <path
                        id="Trazado_34"
                        d="M-70.342-491.679a27.046 27.046 0 0 0-27.016 27.016 27.046 27.046 0 0 0 27.016 27.016 27.046 27.046 0 0 0 27.016-27.016 27.046 27.046 0 0 0-27.016-27.016zm0 49.875A22.885 22.885 0 0 1-93.2-464.663a22.885 22.885 0 0 1 22.859-22.859 22.885 22.885 0 0 1 22.859 22.859 22.885 22.885 0 0 1-22.86 22.863z"
                        class="cls-2"
                        data-name="Trazado 34"
                        transform="translate(105.809 500.13)"
                      />
                      <path
                        id="Trazado_35"
                        d="M39.267-419.363a2.078 2.078 0 0 0 2.078 2.078 2.078 2.078 0 0 0 2.078-2.078 7.665 7.665 0 0 0-3.266-6.071 11.421 11.421 0 0 0-5.047-2.076v-2.244a2.078 2.078 0 0 0-2.078-2.078 2.078 2.078 0 0 0-2.078 2.078v2.244a11.419 11.419 0 0 0-5.047 2.076 7.665 7.665 0 0 0-3.266 6.071 7.665 7.665 0 0 0 3.266 6.071 11.421 11.421 0 0 0 5.047 2.076v8.231c-2.394-.585-4.156-2.139-4.156-3.909a2.078 2.078 0 0 0-2.078-2.078 2.078 2.078 0 0 0-2.078 2.078 7.665 7.665 0 0 0 3.266 6.071 11.421 11.421 0 0 0 5.047 2.076v2.265a2.078 2.078 0 0 0 2.078 2.078 2.078 2.078 0 0 0 2.078-2.078v-2.265a11.42 11.42 0 0 0 5.047-2.076 7.665 7.665 0 0 0 3.266-6.071 7.665 7.665 0 0 0-3.266-6.071 11.421 11.421 0 0 0-5.047-2.076v-8.231c2.394.585 4.156 2.139 4.156 3.909zm-12.469 0c0-1.77 1.762-3.323 4.156-3.909v7.817c-2.394-.585-4.154-2.138-4.154-3.908zm12.469 12.469c0 1.77-1.762 3.323-4.156 3.909v-7.815c2.389.582 4.156 2.136 4.156 3.906z"
                        class="cls-2"
                        data-name="Trazado 35"
                        transform="translate(2.434 448.574)"
                      />
                    </g>
                  </g>
                </svg>
                <p class="mt-2">{{ $t("text_envios_porPrecio") }}</p>
              </el-radio-button>
              <el-radio-button class="w-auto mr-4" label="precio_ciudad">
                <!--  <img loading="lazy"
                  src="../../../assets/city-price.png"
                  :class="choice === 'precio_ciudad' ? 'shadow' : ''"
                /> -->
                <svg
                  class="ml-3"
                  xmlns="http://www.w3.org/2000/svg"
                  width="58.914"
                  height="72"
                  viewBox="0 0 58.914 72"
                >
                  <g
                    id="Grupo_716"
                    data-name="Grupo 716"
                    transform="translate(-1464 -353.25)"
                  >
                    <g
                      id="Grupo_715"
                      data-name="Grupo 715"
                      transform="translate(1417.114 355.25)"
                    >
                      <g
                        id="Grupo_711"
                        data-name="Grupo 711"
                        transform="translate(48.886)"
                      >
                        <g id="Grupo_710" data-name="Grupo 710">
                          <path
                            id="Trazado_36"
                            d="M100.069 12.084a28.062 28.062 0 0 0-46.137 0 28.066 28.066 0 0 0-3.268 25.858 22.1 22.1 0 0 0 4.074 6.726l20.413 23.977a2.428 2.428 0 0 0 3.7 0l20.407-23.97a22.125 22.125 0 0 0 4.073-6.717 28.071 28.071 0 0 0-3.262-25.874zM98.78 36.256a17.335 17.335 0 0 1-3.205 5.251.088.088 0 0 0-.011.013L77 63.322 58.427 41.506a17.345 17.345 0 0 1-3.211-5.266 23.215 23.215 0 0 1 2.714-21.392 23.2 23.2 0 0 1 38.142 0 23.22 23.22 0 0 1 2.708 21.408z"
                            class="cls-1"
                            data-name="Trazado 36"
                            transform="translate(-48.886)"
                          />
                        </g>
                      </g>
                      <g
                        id="Grupo_713"
                        data-name="Grupo 713"
                        transform="translate(63.392 14.418)"
                      >
                        <g id="Grupo_712" data-name="Grupo 712">
                          <path
                            id="Trazado_37"
                            d="M169.362 106.219a13.608 13.608 0 1 0 13.608 13.608 13.624 13.624 0 0 0-13.608-13.608zm0 22.357a8.748 8.748 0 1 1 8.748-8.748 8.758 8.758 0 0 1-8.748 8.748z"
                            class="cls-1"
                            data-name="Trazado 37"
                            transform="translate(-155.754 -106.219)"
                          />
                        </g>
                      </g>
                    </g>
                    <g
                      id="Grupo_714"
                      data-name="Grupo 714"
                      transform="translate(1415.114 353.25)"
                    >
                      <g
                        id="Grupo_711-2"
                        data-name="Grupo 711"
                        transform="translate(48.886)"
                      >
                        <g id="Grupo_710-2" data-name="Grupo 710">
                          <path
                            id="Trazado_36-2"
                            d="M100.069 12.084a28.062 28.062 0 0 0-46.137 0 28.066 28.066 0 0 0-3.268 25.858 22.1 22.1 0 0 0 4.074 6.726l20.413 23.977a2.428 2.428 0 0 0 3.7 0l20.407-23.97a22.125 22.125 0 0 0 4.073-6.717 28.071 28.071 0 0 0-3.262-25.874zM98.78 36.256a17.335 17.335 0 0 1-3.205 5.251.088.088 0 0 0-.011.013L77 63.322 58.427 41.506a17.345 17.345 0 0 1-3.211-5.266 23.215 23.215 0 0 1 2.714-21.392 23.2 23.2 0 0 1 38.142 0 23.22 23.22 0 0 1 2.708 21.408z"
                            class="cls-2"
                            data-name="Trazado 36"
                            transform="translate(-48.886)"
                          />
                        </g>
                      </g>
                      <g
                        id="Grupo_713-2"
                        data-name="Grupo 713"
                        transform="translate(63.392 14.418)"
                      >
                        <g id="Grupo_712-2" data-name="Grupo 712">
                          <path
                            id="Trazado_37-2"
                            d="M169.362 106.219a13.608 13.608 0 1 0 13.608 13.608 13.624 13.624 0 0 0-13.608-13.608zm0 22.357a8.748 8.748 0 1 1 8.748-8.748 8.758 8.758 0 0 1-8.748 8.748z"
                            class="cls-2"
                            data-name="Trazado 37"
                            transform="translate(-155.754 -106.219)"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
                <p class="mt-2">{{ $t("text_envios_porCiudad") }}</p>
              </el-radio-button>
              <el-radio-button class="w-auto mr-4" label="sintarifa">
                <!--  <img loading="lazy"
                  src="../../../assets/free-dev.png"
                  :class="choice === 'gratis' ? 'shadow' : ''"
                /> -->
                <svg
                  id="Grupo_665"
                  xmlns="http://www.w3.org/2000/svg"
                  width="92.211"
                  height="72.73"
                  data-name="Grupo 665"
                  viewBox="0 0 92.211 72.73"
                >
                  <g
                    id="Grupo_663"
                    data-name="Grupo 663"
                    transform="translate(1.623 2.029)"
                  >
                    <path
                      id="Trazado_1"
                      d="M310.878 631.864v8.521c0 .507-.1.913-.1 1.42-.1.2-.1.507-.2.71-.2.406-.406.812-.71 1.319a6.428 6.428 0 0 1-3.043 2.13c-.609.1-1.217.1-1.826.2h-1.927c-.406-.1-.913.1-1.319-.1-.1.507-.2.913-.3 1.42l-.3.913a10.523 10.523 0 0 0-.406 1.014c-.406.609-.812 1.217-1.217 1.927a1.78 1.78 0 0 1-.406.507c-.507.507-1.014.913-1.522 1.42l-.1.1c-.609.406-1.217.71-1.826 1.116-.609.2-1.116.406-1.725.609a.1.1 0 0 0-.1.1l-1.826.3h-1.928a12.311 12.311 0 0 1-3.753-1.116c-.507-.3-1.116-.71-1.623-1.014-.1-.1-.2-.2-.3-.2l-1.623-1.623-.3-.3a13.216 13.216 0 0 0-1.014-1.522c-.2-.609-.507-1.116-.71-1.725a.373.373 0 0 0-.1-.3c-.2-1.217-.2-1.217-1.42-1.217h-.406a13.862 13.862 0 0 1-1.927-.2 4.681 4.681 0 0 1-1.014-.507c-.71-.71-1.217-.507-1.826.1a6.024 6.024 0 0 0-.812.406 11.436 11.436 0 0 1-1.826.3H256.4c-1.522-.1-1.522-.1-1.725 1.217a11.373 11.373 0 0 1-3.855 5.579 24.238 24.238 0 0 0-2.13 1.319c-.406.1-.71.3-1.116.406-.2 0-.3.1-.507.1l-1.826.3h-1.826c-.609-.1-1.217-.2-1.927-.3h-.2c-.507-.2-1.116-.406-1.623-.609a12.376 12.376 0 0 1-3.246-2.435c-.2-.2-.3-.406-.507-.507v-.1a13.167 13.167 0 0 1-1.927-3.753c-.3-1.319-.3-1.319-1.623-1.217h-2.032a11.192 11.192 0 0 1-1.826-.2 6.187 6.187 0 0 1-2.84-1.928 6.809 6.809 0 0 1-1.014-2.333v-24.247c0-.71.2-1.42-.406-2.029a24.543 24.543 0 0 1-1.826-3.652c-.2-.609-.406-1.217-.609-1.927-.1-.507-.2-.913-.3-1.319a24.484 24.484 0 0 1-.2-6.087 22.407 22.407 0 0 1 .812-3.753 12.847 12.847 0 0 0 .609-1.826c.406-.507.507-1.116.913-1.724a22.984 22.984 0 0 1 1.319-2.029.1.1 0 0 0 .1-.1c.507-.609.913-1.116 1.42-1.725a1.222 1.222 0 0 0 .507-.507c.609-.609 1.319-1.116 1.826-1.725.71-.507 1.42-1.014 2.13-1.42a9.633 9.633 0 0 0 1.725-1.014 11.684 11.684 0 0 0 1.725-.609 1.881 1.881 0 0 1 .71-.2c.406-.1.71-.2 1.116-.3a13.046 13.046 0 0 0 1.927-.406c.609-.1 1.217-.1 1.826-.2h1.826c.609 0 1.217.1 1.927.1l1.826.3a23.487 23.487 0 0 1 3.753 1.319 29.988 29.988 0 0 1 3.855 2.333 1.013 1.013 0 0 0 .507.406c.406.406.812.71 1.217 1.116a1.222 1.222 0 0 0 .507.507c.1.1.1.2.2.1v.1c0 .1.1.1.1.2.2.3.406.71.812.71h3.956a1.658 1.658 0 0 0 .71 0h10.956c.406.1.913.1 1.319.2a5.579 5.579 0 0 1 3.145 2.739c.2.609.3 1.116.507 1.725v3.855c.1 0 .1 0 .1-.1-.3.2-.1.507-.1.71 0 .3.2.1.406.1.609-.1 1.116-.1 1.725-.2h15.014c.609.2 1.217.3 1.928.507.609.3 1.116.71 1.725 1.014.609.507 1.116.913 1.725 1.42l.406.406c1.014 1.217 1.927 2.536 2.942 3.754a3.974 3.974 0 0 0 .812 1.014 1.013 1.013 0 0 0 .406.507 7.6 7.6 0 0 0 1.522 2.029c.913 1.319 1.927 2.638 2.84 3.855l.609.913a5.669 5.669 0 0 0 .507.812c.3.609.507 1.116.812 1.724.2.507.3 1.015.507 1.522 0 .2.1.3.1.507a11.181 11.181 0 0 1 .2 1.826v.507a51.72 51.72 0 0 0-.405 8.015zm-83.084-5.174v9.637a8.679 8.679 0 0 0 0 1.623v2.638a1.535 1.535 0 0 0 .71 1.42 1.3 1.3 0 0 0 1.42.609h2.536c.609.1 1.014-.1 1.014-.812a13.2 13.2 0 0 1 1.725-3.855 1.4 1.4 0 0 0 .3-.406l1.522-1.522a.269.269 0 0 0 .3-.3 13.734 13.734 0 0 1 3.855-1.928l1.826-.3h1.826l1.826.3a11.755 11.755 0 0 1 3.753 1.826c.2.2.406.3.609.507a18.7 18.7 0 0 0 1.42 1.42c.1.1.2.3.3.406a15.808 15.808 0 0 1 1.725 3.754c0 .609.2.812.812.812h15.826a1.362 1.362 0 0 0 1.522-.71c.406-.609.2-1.217.2-1.928V598.59a5.542 5.542 0 0 0-.1-1.826c-.3-.913-.71-1.217-1.623-1.116a12.208 12.208 0 0 0-1.927 0 5.516 5.516 0 0 0-1.826 0 6.133 6.133 0 0 0-1.928 0 5.516 5.516 0 0 0-1.826 0h-1.927a5.517 5.517 0 0 0-1.826 0h-.3c-.507 0-1.217-.2-1.42.1s.3.913.507 1.319a5.306 5.306 0 0 0 .609 1.623c.3 1.217.609 2.536.812 3.754 0 .609.1 1.217.1 1.927s-.1 1.319-.1 2.029a11.292 11.292 0 0 0-.2 1.725 22.7 22.7 0 0 1-1.014 3.754c-.3.609-.507 1.217-.812 1.826a.354.354 0 0 1-.1.2 14.2 14.2 0 0 1-1.014 1.623c-.507.609-.913 1.217-1.42 1.826a25.12 25.12 0 0 1-5.275 4.565c-1.116.507-2.333 1.116-3.551 1.623a13.515 13.515 0 0 1-1.928.507c-.609.1-1.116.2-1.725.3-.71.1-1.42.1-2.13.2a3.352 3.352 0 0 0-1.42 0 16.59 16.59 0 0 0-2.232-.2 16.431 16.431 0 0 1-1.927-.406c-.71-.2-1.319-.406-2.029-.609-.3-.1-.609-.3-.913-.406s-.609-.3-.913-.406a5.637 5.637 0 0 0-1.725-.913c-.3-.3-.812-.507-1.116-.812-.3-.2-.507-.406-.812-.609-.1-.1-.2-.3-.3 0v1.014a8.679 8.679 0 0 0 0 1.623v2.029a3.86 3.86 0 0 1 .304 1.836zm79.331 11.869V626.69c0-.3-.1-.406-.406-.406h-16.941c-.71 0-1.319-.1-2.029-.1-.507-.2-1.014-.507-1.623-.71-.3-.2-.609-.507-.913-.71l-.913-1.217c-.1-.2-.2-.3-.3-.507a11.077 11.077 0 0 1-.507-1.724v-5.884a4.366 4.366 0 0 0 0-1.623 11.435 11.435 0 0 1 .3-1.826 3.225 3.225 0 0 0 .3-.913l.913-1.217c.3-.3.609-.507.913-.812a6.346 6.346 0 0 1 3.855-.812 7.619 7.619 0 0 0 1.522 0h2.232a4.91 4.91 0 0 0 1.725 0h2.333a11.59 11.59 0 0 0-4.058-3.348c-.609-.406-1.319-.2-2.029-.2h-13.083c-.913-.1-1.42.406-1.927 1.116-.3.3-.2.812-.2 1.217v33.477a1.558 1.558 0 0 0 .507 1.319 1.667 1.667 0 0 0 1.623.71h.913c.609.1.913-.1.812-.71a1.881 1.881 0 0 0 .2-.71c.1-.406.3-.71.406-1.116.406-.609.71-1.217 1.116-1.826a1.4 1.4 0 0 0 .3-.406c.406-.507.812-.913 1.217-1.42.2-.2.507-.3.71-.609a12.884 12.884 0 0 1 3.753-1.826 11.781 11.781 0 0 0 1.826-.406h1.928l1.826.3a12.43 12.43 0 0 1 3.551 1.623c.406.3.71.609 1.116.913a6.55 6.55 0 0 0 .812.913c.3.3.507.71.812 1.015a15.988 15.988 0 0 1 1.623 3.551c.1.3.1.71.2.913.406-.3.913-.1 1.319-.2h1.927a1.931 1.931 0 0 0 1.725-.71c.1-.1.1-.2.2-.2a1.3 1.3 0 0 0 .406-1.014v-2.029zm-78.215-45.346a6.087 6.087 0 0 0-1.623 1.928 5.448 5.448 0 0 0-1.014 1.623.527.527 0 0 0-.2.406 3.556 3.556 0 0 0-.609 1.42 6.883 6.883 0 0 0-.71 2.029 11.793 11.793 0 0 0-.406 1.826 24.979 24.979 0 0 0-.2 2.638v.812a8.629 8.629 0 0 0 .406 2.232 13.509 13.509 0 0 0 .507 1.927 12.5 12.5 0 0 0 1.927 3.855 4.5 4.5 0 0 0 .812 1.116 1.491 1.491 0 0 0 .507.609 5.09 5.09 0 0 0 1.522 1.42 2.693 2.693 0 0 0 .609.507 3.646 3.646 0 0 0 1.217.812 14.861 14.861 0 0 0 3.845 1.827 16.746 16.746 0 0 0 3.753.609 4.12 4.12 0 0 0 1.927 0 5.618 5.618 0 0 0 1.826-.2 13.047 13.047 0 0 0 1.927-.406 13.179 13.179 0 0 0 4.067-1.832 3.647 3.647 0 0 0 1.217-.812 1.013 1.013 0 0 0 .507-.406 5.088 5.088 0 0 0 1.522-1.42l.406-.406a4.885 4.885 0 0 0 1.217-1.623 3.083 3.083 0 0 0 .507-.71 2.419 2.419 0 0 0 .609-1.116 6.483 6.483 0 0 0 .812-1.928 9.608 9.608 0 0 0 .507-1.826v-.2a5.153 5.153 0 0 0 .3-1.724 11.021 11.021 0 0 0 .1-1.826 13.864 13.864 0 0 0-.2-1.927c-.1-.406 0-.913-.3-1.217v-.609a6.118 6.118 0 0 0-.609-1.927 12.332 12.332 0 0 0-2.232-3.855 4.362 4.362 0 0 0-.913-1.015 2.373 2.373 0 0 0-.71-.71 6.624 6.624 0 0 0-1.222-1.114 2.318 2.318 0 0 0-1.014-.71 1.819 1.819 0 0 0-.71-.507 7.6 7.6 0 0 0-2.029-1.015 12.927 12.927 0 0 0-3.855-1.116 11.312 11.312 0 0 0-1.725-.2h-1.826a13.879 13.879 0 0 0-1.927.2 12.52 12.52 0 0 0-3.754 1.217 11.564 11.564 0 0 0-3.043 1.826l-1.522 1.217c-.102.199-.203.199-.203.301zm69.19 52.042v-.2a2.9 2.9 0 0 0 0-1.319 5.891 5.891 0 0 0-1.725-3.957 2.077 2.077 0 0 0-.812-.811 7.034 7.034 0 0 0-3.855-1.725 5.523 5.523 0 0 0-1.826 0 7.429 7.429 0 0 0-2.536.812 7.1 7.1 0 0 0-3.652 5.681 4.369 4.369 0 0 0 0 1.623 3.762 3.762 0 0 0 .406 1.522v.1a.775.775 0 0 0 .2.507 6.393 6.393 0 0 0 3.551 3.348 1.416 1.416 0 0 0 .913.3 4.315 4.315 0 0 0 1.116.2 4.367 4.367 0 0 0 1.623 0 5.092 5.092 0 0 0 1.217-.2.921.921 0 0 0 .71-.3 6.84 6.84 0 0 0 4.362-5.579c.308.099.308-.002.308-.002zm-10.652-24.043a1.477 1.477 0 0 0 .609.913 1.931 1.931 0 0 0 1.927.507h3.956a9.75 9.75 0 0 0 1.725 0h9.535a3.834 3.834 0 0 0 1.522 0c.71.1.3-.406.3-.609a1.152 1.152 0 0 0-.3-.812 7.085 7.085 0 0 0-.812-2.029 2.767 2.767 0 0 0-.71-1.319.556.556 0 0 0-.406-.609 33.534 33.534 0 0 0-2.232-3.043l-.2-.2-.1-.1a5.466 5.466 0 0 0-.913-1.217c-.3-1.015-1.116-.811-1.826-.811a6.133 6.133 0 0 0-1.927 0 5.516 5.516 0 0 0-1.826 0 12.208 12.208 0 0 0-1.927 0c-.609-.1-1.217.2-1.826.1a4.142 4.142 0 0 0-1.928-.1 2.256 2.256 0 0 0-1.623.3 1.563 1.563 0 0 0-.913 1.319v3.855a6.138 6.138 0 0 0 0 1.927 3.1 3.1 0 0 0-.109 1.928zm-36.318 24.347a6.55 6.55 0 0 0 0-2.435 5.562 5.562 0 0 0-1.42-3.246 3.225 3.225 0 0 0-1.014-1.014 5.767 5.767 0 0 0-3.754-1.623 6.149 6.149 0 0 0-1.927 0 6.26 6.26 0 0 0-3.855 1.826 2.4 2.4 0 0 0-.812.913 4.309 4.309 0 0 0-1.014 1.725c0 .1 0 .2-.1.2a4.78 4.78 0 0 0-.406 1.725 6.28 6.28 0 0 0 .812 4.058 6.353 6.353 0 0 0 3.449 3.246 7.35 7.35 0 0 0 5.681.1 5.32 5.32 0 0 0 1.927-1.116c.2-.1.3-.3.507-.406a4.413 4.413 0 0 0 1.319-2.029v-.1a4.325 4.325 0 0 0 .604-1.824z"
                      class="cls-1"
                      data-name="Trazado 1"
                      transform="translate(-221.196 -585.3)"
                    />
                    <path
                      id="Trazado_2"
                      d="M242.029 591.826c-.1 2.841-.1 5.58 0 8.42v1.217c0 .3-.1.71.1.913a3.9 3.9 0 0 1 .913 1.826v.406c0 .2-.1.406-.1.609a3.586 3.586 0 0 1-1.623 2.029c-.406 0-.71.3-1.014.2a.771.771 0 0 0-.913.507l-.3.3-1.522 1.522-.3.3a12.338 12.338 0 0 1-1.725 1.522h-.1c-1.42.3-2.232-.406-2.435-1.927l.3-.913a.354.354 0 0 1 .1-.2 1.407 1.407 0 0 0 .71-.812h.1l.609-.609a19.968 19.968 0 0 0 2.536-2.536v-.71a3.721 3.721 0 0 1 1.014-1.725 5.518 5.518 0 0 0 0-1.826 5.519 5.519 0 0 0 0-1.826 6.134 6.134 0 0 0 0-1.927 5.518 5.518 0 0 0 0-1.826 12.211 12.211 0 0 0 0-1.927 11.172 11.172 0 0 1 .2-1.826 1.82 1.82 0 0 0 .507-.71 1.972 1.972 0 0 1 1.826-.2 2.162 2.162 0 0 1 1.014 1.116 1.785 1.785 0 0 1 .103.613z"
                      class="cls-1"
                      data-name="Trazado 2"
                      transform="translate(-221.025 -585.232)"
                    />
                  </g>
                  <g id="Grupo_664" data-name="Grupo 664">
                    <path
                      id="Trazado_3"
                      d="M309.278 629.864v8.521c0 .507-.1.913-.1 1.42-.1.2-.1.507-.2.71-.2.406-.406.812-.71 1.319a6.426 6.426 0 0 1-3.043 2.13c-.609.1-1.217.1-1.826.2h-1.928c-.406-.1-.913.1-1.319-.1-.1.507-.2.913-.3 1.42l-.3.913a10.524 10.524 0 0 0-.406 1.014c-.406.609-.812 1.217-1.217 1.927a1.78 1.78 0 0 1-.406.507c-.507.507-1.015.913-1.522 1.42l-.1.1c-.609.406-1.217.71-1.826 1.116-.609.2-1.116.406-1.725.609a.1.1 0 0 0-.1.1l-1.826.3h-1.927a12.314 12.314 0 0 1-3.753-1.116c-.507-.3-1.116-.71-1.623-1.014-.1-.1-.2-.2-.3-.2l-1.623-1.623-.3-.3a13.221 13.221 0 0 0-1.014-1.522c-.2-.609-.507-1.116-.71-1.725a.373.373 0 0 0-.1-.3c-.2-1.217-.2-1.217-1.42-1.217h-.406a13.872 13.872 0 0 1-1.927-.2 4.673 4.673 0 0 1-1.014-.507c-.71-.71-1.217-.507-1.826.1a6.016 6.016 0 0 0-.812.406 11.442 11.442 0 0 1-1.826.3H254.8c-1.522-.1-1.522-.1-1.725 1.217a11.373 11.373 0 0 1-3.855 5.58 24.257 24.257 0 0 0-2.13 1.319c-.406.1-.71.3-1.116.406-.2 0-.3.1-.507.1l-1.826.3h-1.826c-.609-.1-1.217-.2-1.927-.3h-.2c-.507-.2-1.116-.406-1.623-.609a12.377 12.377 0 0 1-3.246-2.435c-.2-.2-.3-.406-.507-.507v-.1a13.166 13.166 0 0 1-1.927-3.753c-.3-1.319-.3-1.319-1.623-1.217h-2.032a11.172 11.172 0 0 1-1.826-.2 6.186 6.186 0 0 1-2.84-1.927 6.811 6.811 0 0 1-1.014-2.333v-24.249c0-.71.2-1.42-.406-2.029a24.557 24.557 0 0 1-1.826-3.652c-.2-.609-.406-1.217-.609-1.927-.1-.507-.2-.913-.3-1.319a24.482 24.482 0 0 1-.2-6.087 22.406 22.406 0 0 1 .812-3.754 12.844 12.844 0 0 0 .609-1.826c.406-.507.507-1.116.913-1.724a22.927 22.927 0 0 1 1.319-2.029.1.1 0 0 0 .1-.1c.507-.609.913-1.116 1.42-1.725a1.223 1.223 0 0 0 .507-.507c.609-.609 1.319-1.116 1.826-1.725.71-.507 1.42-1.014 2.13-1.42a9.642 9.642 0 0 0 1.725-1.015 11.664 11.664 0 0 0 1.725-.609 1.878 1.878 0 0 1 .71-.2c.406-.1.71-.2 1.116-.3a13.048 13.048 0 0 0 1.927-.406c.609-.1 1.217-.1 1.826-.2h1.826c.609 0 1.217.1 1.927.1l1.826.3a23.475 23.475 0 0 1 3.754 1.319 30.01 30.01 0 0 1 3.855 2.333 1.012 1.012 0 0 0 .507.406c.406.406.812.71 1.217 1.116a1.221 1.221 0 0 0 .507.507c.1.1.1.2.2.1v.1c0 .1.1.1.1.2.2.3.406.71.812.71h3.956a1.657 1.657 0 0 0 .71 0h10.956c.406.1.913.1 1.319.2a5.578 5.578 0 0 1 3.145 2.739c.2.609.3 1.116.507 1.725v3.855c.1 0 .1 0 .1-.1-.3.2-.1.507-.1.71 0 .3.2.1.406.1.609-.1 1.116-.1 1.725-.2h15.014c.609.2 1.217.3 1.927.507.609.3 1.116.71 1.725 1.014.609.507 1.116.913 1.725 1.42l.406.406c1.014 1.217 1.927 2.536 2.942 3.754a3.971 3.971 0 0 0 .812 1.014 1.012 1.012 0 0 0 .406.507 7.6 7.6 0 0 0 1.522 2.029c.913 1.319 1.927 2.638 2.84 3.855l.609.913a5.667 5.667 0 0 0 .507.812c.3.609.507 1.116.812 1.725.2.507.3 1.015.507 1.522 0 .2.1.3.1.507a11.179 11.179 0 0 1 .2 1.826v.507a51.069 51.069 0 0 0-.405 8.016zm-83.084-5.275v9.637a8.673 8.673 0 0 0 0 1.623v2.638a1.535 1.535 0 0 0 .71 1.42 1.3 1.3 0 0 0 1.42.609h2.536c.609.1 1.014-.1 1.014-.812a13.2 13.2 0 0 1 1.725-3.855 1.4 1.4 0 0 0 .3-.406l1.522-1.522a.269.269 0 0 0 .3-.3 13.73 13.73 0 0 1 3.855-1.927l1.826-.3h1.826l1.826.3a11.749 11.749 0 0 1 3.753 1.826c.2.2.406.3.609.507a18.713 18.713 0 0 0 1.42 1.42c.1.1.2.3.3.406a15.809 15.809 0 0 1 1.725 3.754c0 .609.2.811.812.811h15.826a1.362 1.362 0 0 0 1.522-.71c.406-.609.2-1.217.2-1.927v-41.293a5.541 5.541 0 0 0-.1-1.826c-.3-.913-.71-1.217-1.623-1.116a12.2 12.2 0 0 0-1.927 0 5.513 5.513 0 0 0-1.826 0 6.129 6.129 0 0 0-1.927 0 5.513 5.513 0 0 0-1.826 0 12.2 12.2 0 0 0-1.927 0 5.513 5.513 0 0 0-1.826 0h-.3c-.507 0-1.217-.2-1.42.1s.3.913.507 1.319a5.3 5.3 0 0 0 .609 1.623c.3 1.217.609 2.536.812 3.753 0 .609.1 1.217.1 1.928s-.1 1.319-.1 2.029a11.3 11.3 0 0 0-.2 1.725 22.708 22.708 0 0 1-1.014 3.753c-.3.609-.507 1.217-.812 1.826a.354.354 0 0 1-.1.2 14.216 14.216 0 0 1-1.014 1.623c-.507.609-.913 1.217-1.42 1.826a25.113 25.113 0 0 1-5.275 4.565c-1.116.507-2.333 1.116-3.551 1.623a13.532 13.532 0 0 1-1.927.507c-.609.1-1.116.2-1.725.3-.71.1-1.42.1-2.13.2a3.348 3.348 0 0 0-1.42 0 16.569 16.569 0 0 0-2.232-.2 16.522 16.522 0 0 1-1.927-.406c-.71-.2-1.319-.406-2.029-.609-.3-.1-.609-.3-.913-.406s-.609-.3-.913-.406a5.642 5.642 0 0 0-1.725-.913c-.3-.3-.812-.507-1.116-.812-.3-.2-.507-.406-.812-.609-.1-.1-.2-.3-.3 0v1.014a8.675 8.675 0 0 0 0 1.623v2.029a4.289 4.289 0 0 1 .302 1.838zm79.432 11.869v-11.869c0-.3-.1-.406-.406-.406h-16.941c-.71 0-1.319-.1-2.029-.1-.507-.2-1.014-.507-1.623-.71-.3-.2-.609-.507-.913-.71l-.913-1.217c-.1-.2-.2-.3-.3-.507a11.086 11.086 0 0 1-.507-1.724v-5.884a4.367 4.367 0 0 0 0-1.623 11.438 11.438 0 0 1 .3-1.826 3.222 3.222 0 0 0 .3-.913l.913-1.217c.3-.3.609-.507.913-.812a6.346 6.346 0 0 1 3.855-.812 7.619 7.619 0 0 0 1.522 0h2.232a4.909 4.909 0 0 0 1.725 0h2.333a11.592 11.592 0 0 0-4.058-3.348c-.609-.406-1.319-.2-2.029-.2h-13.083c-.913-.1-1.42.406-1.927 1.116-.3.3-.2.812-.2 1.217v33.477a1.558 1.558 0 0 0 .507 1.319 1.666 1.666 0 0 0 1.623.71h.913c.609.1.913-.1.812-.71a1.88 1.88 0 0 0 .2-.71c.1-.406.3-.71.406-1.116.406-.609.71-1.217 1.116-1.826a1.4 1.4 0 0 0 .3-.406c.406-.507.812-.913 1.217-1.42.2-.2.507-.3.71-.609a12.887 12.887 0 0 1 3.753-1.826 11.782 11.782 0 0 0 1.826-.406h1.927l1.826.3a12.429 12.429 0 0 1 3.551 1.623c.406.3.71.609 1.116.913a6.576 6.576 0 0 0 .812.913c.3.3.507.71.812 1.015a15.989 15.989 0 0 1 1.623 3.55c.1.3.1.71.2.913.406-.3.913-.1 1.319-.2h1.927a1.931 1.931 0 0 0 1.725-.71c.1-.1.1-.2.2-.2a1.3 1.3 0 0 0 .406-1.014v-2.029zm-78.316-45.245a6.089 6.089 0 0 0-1.623 1.928 5.451 5.451 0 0 0-1.014 1.623.527.527 0 0 0-.2.406 3.557 3.557 0 0 0-.609 1.42 6.886 6.886 0 0 0-.71 2.029 11.8 11.8 0 0 0-.406 1.826 24.978 24.978 0 0 0-.2 2.638v.812a8.624 8.624 0 0 0 .406 2.232 13.512 13.512 0 0 0 .507 1.928 12.5 12.5 0 0 0 1.927 3.855 4.5 4.5 0 0 0 .812 1.116 1.49 1.49 0 0 0 .507.609 5.089 5.089 0 0 0 1.522 1.42 2.685 2.685 0 0 0 .609.507 3.648 3.648 0 0 0 1.217.812 14.862 14.862 0 0 0 3.845 1.826 16.754 16.754 0 0 0 3.754.609 4.119 4.119 0 0 0 1.927 0 5.616 5.616 0 0 0 1.826-.2 13.021 13.021 0 0 0 1.927-.406 13.181 13.181 0 0 0 4.058-1.826 3.647 3.647 0 0 0 1.217-.812 1.012 1.012 0 0 0 .507-.406 5.088 5.088 0 0 0 1.522-1.42l.406-.406a4.882 4.882 0 0 0 1.217-1.623 3.084 3.084 0 0 0 .507-.71 2.418 2.418 0 0 0 .609-1.116 6.482 6.482 0 0 0 .812-1.927 9.6 9.6 0 0 0 .507-1.826v-.2a5.151 5.151 0 0 0 .3-1.725 11.019 11.019 0 0 0 .1-1.826 13.869 13.869 0 0 0-.2-1.927c-.1-.406 0-.913-.3-1.217v-.609a6.12 6.12 0 0 0-.609-1.927 12.333 12.333 0 0 0-2.232-3.855 4.36 4.36 0 0 0-.913-1.014 2.371 2.371 0 0 0-.71-.71 6.626 6.626 0 0 0-1.214-1.121 2.318 2.318 0 0 0-1.014-.71 1.82 1.82 0 0 0-.71-.507 7.608 7.608 0 0 0-2.029-1.014 12.926 12.926 0 0 0-3.855-1.116 11.3 11.3 0 0 0-1.725-.2h-1.826a13.862 13.862 0 0 0-1.927.2 12.517 12.517 0 0 0-3.754 1.217 11.562 11.562 0 0 0-3.043 1.826l-1.522 1.217c-.102.097-.102.198-.203.3zm69.186 51.94v-.2a2.9 2.9 0 0 0 0-1.319 5.89 5.89 0 0 0-1.725-3.956 2.076 2.076 0 0 0-.812-.812 7.034 7.034 0 0 0-3.855-1.725 5.52 5.52 0 0 0-1.826 0 7.426 7.426 0 0 0-2.536.812 7.1 7.1 0 0 0-3.652 5.681 4.367 4.367 0 0 0 0 1.623 3.762 3.762 0 0 0 .406 1.522v.1a.775.775 0 0 0 .2.507 6.392 6.392 0 0 0 3.551 3.348 1.415 1.415 0 0 0 .913.3 4.314 4.314 0 0 0 1.116.2 4.364 4.364 0 0 0 1.623 0 5.092 5.092 0 0 0 1.217-.2.921.921 0 0 0 .71-.3 6.84 6.84 0 0 0 4.362-5.579c.312.201.312.1.312-.002zm-10.652-24.043a1.478 1.478 0 0 0 .609.913 2.243 2.243 0 0 0 1.927.609h3.956a9.768 9.768 0 0 0 1.725 0h9.539a3.84 3.84 0 0 0 1.522 0c.71.1.3-.406.3-.609a1.152 1.152 0 0 0-.3-.812 7.082 7.082 0 0 0-.812-2.029 2.769 2.769 0 0 0-.71-1.319.556.556 0 0 0-.406-.609 33.513 33.513 0 0 0-2.232-3.043l-.2-.2-.1-.1a5.461 5.461 0 0 0-.913-1.217c-.3-1.014-1.116-.812-1.826-.812a6.136 6.136 0 0 0-1.927 0 5.52 5.52 0 0 0-1.826 0 12.215 12.215 0 0 0-1.927 0c-.609-.1-1.217.2-1.826.1a4.143 4.143 0 0 0-1.927-.1 2.255 2.255 0 0 0-1.623.3 1.563 1.563 0 0 0-.913 1.319v3.855a6.144 6.144 0 0 0 0 1.927 3.725 3.725 0 0 0-.11 1.827zm-36.318 24.449a6.548 6.548 0 0 0 0-2.435 5.562 5.562 0 0 0-1.42-3.246 3.224 3.224 0 0 0-1.014-1.014 5.766 5.766 0 0 0-3.754-1.623 6.138 6.138 0 0 0-1.927 0 6.259 6.259 0 0 0-3.855 1.826 2.4 2.4 0 0 0-.812.913 4.309 4.309 0 0 0-1.014 1.724c0 .1 0 .2-.1.2a4.781 4.781 0 0 0-.406 1.724 6.28 6.28 0 0 0 .812 4.058 6.354 6.354 0 0 0 3.449 3.246 7.35 7.35 0 0 0 5.681.1 5.318 5.318 0 0 0 1.927-1.116c.2-.1.3-.3.507-.406a4.413 4.413 0 0 0 1.319-2.029v-.1a4.324 4.324 0 0 0 .608-1.822z"
                      class="cls-2"
                      data-name="Trazado 3"
                      transform="translate(-219.596 -583.3)"
                    />
                    <path
                      id="Trazado_4"
                      d="M240.529 589.827c-.1 2.84-.1 5.579 0 8.42v1.217c0 .3-.1.71.1.913a3.9 3.9 0 0 1 .913 1.826v.406c0 .2-.1.406-.1.609a3.586 3.586 0 0 1-1.623 2.029c-.406 0-.71.3-1.014.2a.771.771 0 0 0-.913.507l-.3.3-1.522 1.522-.3.3a12.341 12.341 0 0 1-1.725 1.522h-.1c-1.42.3-2.232-.406-2.435-1.927l.3-.913a.354.354 0 0 1 .1-.2 1.408 1.408 0 0 0 .71-.812h.1l.609-.609a29.939 29.939 0 0 0 2.536-2.536v-.71a3.721 3.721 0 0 1 1.014-1.724 5.516 5.516 0 0 0 0-1.826 5.514 5.514 0 0 0 0-1.826 6.132 6.132 0 0 0 0-1.928 5.514 5.514 0 0 0 0-1.826 12.206 12.206 0 0 0 0-1.928 11.181 11.181 0 0 1 .2-1.826 1.819 1.819 0 0 0 .507-.71 1.972 1.972 0 0 1 1.826-.2 2.163 2.163 0 0 1 1.014 1.116 1.1 1.1 0 0 0 .103.614z"
                      class="cls-2"
                      data-name="Trazado 4"
                      transform="translate(-219.424 -583.232)"
                    />
                  </g>
                </svg>
                <p class="mt-2">{{ $t("text_envios_sintarifa") }}</p>
              </el-radio-button>
              <el-radio-button class="w-auto" label="sinEnvio">
                <svg
                  width="90"
                  height="72.73"
                  class="cls-2"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.477 3.11a6 6 0 0 0-8.367 8.367l8.367-8.368zm1.414 1.413l-8.368 8.368a6 6 0 0 0 8.367-8.367zM8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0z"
                    fill-rule="evenodd"
                  />
                </svg>
                <p class="mt-2">{{ $t("text_envios_sinEnvio") }}</p>
              </el-radio-button>
            </el-radio-group>
            <div class="delivery_content">
              <p class="font-extrabol text-lg mb-2">
                <strong :class="darkMode ? 'darktxtswiper' : 'lighttxtswiper'">
                  {{ $t(getDeliveryContent(choice).title) }}
                </strong>
              </p>
              <p class="description" :class="darkMode ? 'darktxt' : 'lighttxt'">
                {{ $t(getDeliveryContent(choice).desc) }}
              </p>
              <div v-if="getDeliveryContent(choice).type == 'uniqueValue'">
                <div class="input-area">
                  <p
                    class="text-info"
                    :class="darkMode ? 'darktxt' : 'lighttxt2'"
                  >
                    {{ $t("text_envios_valorEnvio") }}
                  </p>
                  <div class="el-input w-full">
                    <money
                      v-model="price"
                      v-bind="money"
                      class="money-idTienda w-full"
                      :class="darkMode ? 'darks-money' : 'light-money'"
                    ></money>
                  </div>
                </div>
              </div>
              <div
                v-if="getDeliveryContent(choice).type == 'rangeValue'"
                class="wrapper-ranges"
              >
                <!-- tarifa por precio -->
                <div v-show="choice == 'precio'" class="wrapper-ranges">
                  <div
                    v-for="(range, index) in priceRanges"
                    :key="`range_${index}`"
                    class="range grid"
                  >
                    <div class="input-area">
                      <p
                        class="text-info"
                        :class="darkMode ? 'darktxt' : 'lighttxt2'"
                      >
                        Para
                      </p>
                      <div class="el-input is-disabled">
                        <money
                          v-model="range.inicial"
                          v-bind="money"
                          :class="darkMode ? 'darks-money' : 'light-money'"
                          class="money-idTienda"
                          disabled
                        ></money>
                      </div>
                    </div>
                    <div class="input-area">
                      <p
                        class="text-info"
                        :class="darkMode ? 'darktxt' : 'lighttxt2'"
                      >
                        Hasta
                      </p>
                      <div
                        v-if="priceRanges?.length - 1 !== index"
                        class="el-input is-disabled"
                      >
                        <money
                          v-model="range.final"
                          v-bind="money"
                          :class="darkMode ? 'darks-money' : 'light-money'"
                          class="money-idTienda"
                          disabled
                        ></money>
                      </div>
                      <div v-else class="el-input">
                        <money
                          v-model="range.final"
                          v-bind="money"
                          :class="darkMode ? 'darks-money' : 'light-money'"
                          class="money-idTienda"
                        ></money>
                      </div>
                    </div>
                    <div class="input-area">
                      <p
                        class="text-info"
                        :class="darkMode ? 'darktxt' : 'lighttxt2'"
                      >
                        {{ $t("text_envios_valorEnvio") }}
                      </p>
                      <div class="el-input">
                        <money
                          v-model="range.precio"
                          v-bind="money"
                          :class="darkMode ? 'darks-money' : 'light-money'"
                          class="money-idTienda"
                        ></money>
                      </div>
                    </div>
                    <el-button
                      v-if="index + 1 != 1"
                      class="bg-transparent"
                      style="color: red"
                      type="danger"
                      icon="el-icon-delete"
                      @click="deletePriceRange(index)"
                    ></el-button>
                  </div>
                  <el-button
                    class="pull-right mt-2"
                    plain
                    type="primary"
                    @click="addPriceRange"
                  >
                    <i class="el-icon-circle-plus-outline" />
                    {{ $t("text_envios_agregarRango") }}
                  </el-button>
                  <!-- <MethodShip /> -->
                </div>
                <!-- tarifa por ciudad -->
                <div
                  v-show="choice == 'precio_ciudad'"
                  class="wrapper-ranges wrapper-ranges-ciudad"
                >
                  <div class="wrapper-scroll-cities">
                    <template v-for="(city, index) in priceCities">
                      <div
                        v-if="city.id != 0"
                        :key="index"
                        class="range grid-cities city"
                      >
                        <div class="input-area">
                          <p
                            class="text-info"
                            :class="darkMode ? 'darktxt' : 'lighttxt2'"
                          >
                            {{ $t("text_perfil_ciudad") }}
                            <span
                              v-if="index == 0"
                              class="ml-2 animate-pulse text-new text-yellow-300"
                            >
                              ✨ Nuevo
                            </span>
                          </p>
                          <el-select
                            v-model="city.id"
                            :placeholder="$t('text_envios_escribeCiudad')"
                            filterable
                            clearable
                            remote
                            :remote-method="remoteMethod"
                            :loading="loading"
                            :disabled="city.id == 0"
                            class="inputs-idTienda"
                            :class="darkMode ? 'darks-input' : 'light-input'"
                          >
                            <el-option
                              v-for="(item, index2) in options"
                              :key="`${item.id}-${index2}`"
                              :label="
                                item.id == 0
                                  ? `${$t('text_envios_restoPais')}`
                                  : item.nombre_ciu
                              "
                              :value="item.id"
                              :data_testid="`ciudad_${index2}`"
                            ></el-option>
                          </el-select>
                        </div>
                        <div class="input-area">
                          <p
                            class="text-info"
                            :class="darkMode ? 'darktxt' : 'lighttxt2'"
                          >
                            {{ $t("text_envios_tiempoEntrega") }}
                          </p>
                          <el-input
                            v-model="city.deliveryTime"
                            required
                            :placeholder="$t('text_envios_dias')"
                            class="inputs-idTienda"
                            :class="darkMode ? 'darks-input' : 'light-input'"
                          ></el-input>
                        </div>
                        <div class="input-area">
                          <p
                            class="text-info"
                            :class="darkMode ? 'darktxt' : 'lighttxt2'"
                          >
                            {{ $t("text_envios_valorEnvio") }}
                          </p>
                          <div class="el-input">
                            <money
                              v-model="city.price"
                              required
                              v-bind="money"
                              class="money-idTienda"
                              :class="darkMode ? 'darks-money' : 'light-money'"
                            ></money>
                          </div>
                        </div>
                        <el-button
                          v-if="index + 1 != 1"
                          class="bg-transparent"
                          style="color: red"
                          type="danger"
                          icon="el-icon-delete"
                          @click="deletePriceCity(index, city)"
                        ></el-button>
                      </div>
                    </template>
                  </div>
                  <el-button
                    plain
                    type="text"
                    class="pull-right"
                    @click="addPriceCity"
                  >
                    <i class="el-icon-circle-plus-outline" />
                    {{ $t("text_envios_addCiudad") }}
                  </el-button>
                  <div
                    v-if="
                      priceCities?.length &&
                      priceCities[priceCities.length - 1].price != -1
                    "
                    class="grid-bont"
                  >
                    <div class="btn-radio" @click="eliminarRestoDelPais">
                      <div class="btn-intRadio"></div>
                    </div>
                    <div class="input-area">
                      <p
                        class="font-extrabold"
                        :class="darkMode ? 'darktxtswiper' : 'lighttxtswiper'"
                      >
                        {{ $t("text_envios_tarifaPais") }}
                      </p>
                      <p :class="darkMode ? 'darktxt' : 'lighttxt'">
                        {{ $t("text_envios_tarifaPaisInfo") }}
                      </p>
                    </div>
                    <div class="input-area">
                      <p
                        class="text-info"
                        :class="darkMode ? 'darktxt' : 'lighttxt2'"
                      >
                        {{ $t("text_envios_tiempoEntrega") }}
                      </p>
                      <el-input
                        v-model="cityDefault.deliveryTime"
                        v-validate="'required'"
                        required
                        data-vv-name="tiempo"
                        auto-complete="on"
                        placeholder="1 días"
                        class="inputs-idTienda"
                        :class="darkMode ? 'darks-input' : 'light-input'"
                      ></el-input>
                    </div>
                    <div class="input-area">
                      <p
                        class="text-info"
                        :class="darkMode ? 'darktxt' : 'lighttxt2'"
                      >
                        {{ $t("text_envios_valorEnvio") }}
                      </p>
                      <div class="el-input">
                        <money
                          v-model="cityDefault.price"
                          style="max-width: 130px"
                          v-bind="money"
                          class="money-idTienda"
                          :class="darkMode ? 'darks-money' : 'light-money'"
                        ></money>
                      </div>
                    </div>
                  </div>
                  <el-button
                    v-else
                    type="primary"
                    style="width: 100%; margin-top: 10px; margin-left: 0px"
                    plain
                    @click="habilitarRestoDelPais()"
                  >
                    {{ $t("text_envios_HabilitarRestoPais") }}
                  </el-button>
                  <!-- <MethodShip /> -->
                </div>
              </div>
            </div>
            <MethodShip :dark-mode="darkMode" :store-data="storeData" />
          </div>
        </swiper-slide>
        <swiper-slide class="slide-2">
          <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 column editor">
            <h5 class="policy-title" :class="darkMode ? 'darktxt' : 'lighttxt'">
              {{ $t("text_envios_politicasEnviosT") }}
              <sliderInformation :numberId="28" :actions="true" class="ml-2" />
            </h5>
            <p
              class="policy-description"
              :class="darkMode ? 'darktxt' : 'lighttxt'"
            >
              {{ $t("text_envios_politicasEnvioInfo") }}
            </p>
            <vue-editor
              id="pago"
              v-model="shippingPolicies"
              class="bg-white"
              @focus="changeState"
            ></vue-editor>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="wrapper-buttons">
      <el-button
        type="primary"
        data_testid="button"
        class="pull-right"
        @click="updateShipping"
      >
        {{ $t("text_inventario_guardar") }}
      </el-button>
      <el-button v-if="toggleSwipper" class="pull-right" @click="prev">
        {{ $t("text_inventario_cancelar") }}
      </el-button>
      <el-button v-if="!toggleSwipper" class="pull-right">
        {{ $t("text_inventario_cancelar") }}
      </el-button>
    </div>
    <ModalMap :city="city.id" :zonas="zonas" :visible.sync="dialogVisible" />
  </div>
</template>
<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";
import { mapState } from "vuex";
import MethodShip from "@/components/Method-envios";
import ModalMap from "@/components/shipping/ModalMap.vue";
import normalizeString from "@/mixins/normalizeString";
import setFormatMoney from "@/mixins/formatCurrent";
import sliderInformation from "@/components/information.vue";
export default {
  name: "ShippingNational",
  components: {
    VueEditor,
    ModalMap,
    MethodShip,
    sliderInformation,
  },
  mixins: [normalizeString, setFormatMoney],
  data() {
    return {
      city: {},
      restoDelPais: true,
      dialogVisible: false,
      options: [],
      loading: false,
      camposvacios: false,
      toggleSwipper: false,
      swiperOption: {
        simulateTouch: false,
        autoHeight: true,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      // priceCity: {
      //   city: "",
      // },
      cityDefault: { deliveryTime: "1-2 días", id: 0, price: 0 },
      loaderShipping: true,
      price: 0,
      weight: {
        decimal: ",",
        thousands: ".",
        prefix: "Kg ",
        suffix: " ",
        precision: 0,
        masked: false,
      },
      choice: "gratis",
      deliveryContent: {
        gratis: {
          title: "text_envios_enviosGratis",
          desc: "text_envios_desc1",
        },
        tarifa_plana: {
          title: "text_envios_tarifaPlana",
          desc: "text_envios_desc2",
          type: "uniqueValue",
        },
        precio: {
          title: "text_envios_tarifaporPrecio",
          desc: "text_envios_desc3",
          type: "rangeValue",
        },
        precio_ciudad: {
          title: "text_envios_tarifaporCiudad",
          desc: "text_envios_desc4",
          type: "rangeValue",
        },
        sintarifa: {
          title: "text_envios_sintarifa",
          desc: "text_envios_desc5",
        },
        sinEnvio: {
          title: "text_envios_sinEnvio",
          desc: "text_envios_desc6",
        },
      },
      priceRanges: [{ inicial: 0, final: 0, precio: 0 }],
      priceCities: [{ id: "", price: 0, deliveryTime: "" }],
      weightRanges: [{ inicial: 0, final: 0, precio: 0 }],
      updateShippingPolicies: false,
      zonas: [],
    };
  },
  $_veeValidate: {
    validator: "new",
  },
  computed: {
    ...mapState(["storeData", "darkMode", "dataHoko"]),
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    shippingData() {
      return this.$store.state.shippingData[0];
    },
    hideDefault() {
      let bool = false;
      if (
        !Object.prototype.hasOwnProperty.call(
          this.shippingData.valores,
          "rangos"
        )
      ) {
        bool = true;
      }
      return bool;
    },
    cities() {
      return this.$store.state.cities.filter(
        (cities) =>
          cities.departamento.paises_id ===
          this.storeData.informacion_tienda[0].paises_id
      );
    },
    shippingPolicies: {
      get() {
        return this.$store.state.shippingPolicies;
      },
      set(newValue) {
        this.$store.state.shippingPolicies = newValue;
      },
    },
  },
  watch: {
    shippingData(value) {
      this.showData(value);
    },
    priceCities() {
      this.priceCities.forEach((item) => {
        if (item.id == 0) {
          this.cityDefault = item;
        }
      });
      this.addPriceCities();
    },
    cities() {
      this.addPriceCities();
    },
  },

  mounted() {
    // this.priceCities.forEach((item, index) => {
    //   if (item.id == 0) {
    //     this.cityDefault.slice(index, 1, item)
    //   }
    // })
    if (this.cities?.length > 0) {
      this.priceCities[0].id = this.cities[1].id;
    }
    this.addPriceCities();
  },
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.cities.slice(1).filter((item) => {
            return (
              this.normalize(item.nombre_ciu).indexOf(this.normalize(query)) >
              -1
            );
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    addPriceCities() {
      this.options = [];
      let idCities = [];
      // console.log(this.priceCities);
      this.cities.forEach((city) => {
        this.priceCities.forEach((element) => {
          if (
            city.id === element.id &&
            element.id !== 0 &&
            idCities.indexOf(element.id) === -1
          ) {
            this.options.push(city);
            idCities.push(city.id);
          }
        });
      });
    },
    addPriceCity() {
      this.priceCities.splice(
        this.priceCities[this.priceCities.length - 1],
        0,
        {
          id: this.cities[1].id,
          price: 0,
          deliveryTime: "1-2 días",
        }
      );
    },
    changeState() {
      this.updateShippingPolicies = true;
    },
    showData(value) {
      if (typeof value.valores === "string")
        value.valores = JSON.parse(value.valores);
      this.choice = value.valores.envio_metodo;
      if (this.choice === "precio") this.priceRanges = value.valores.rangos;
      if (this.choice === "peso") this.weightRanges = value.valores.rangos;
      if (this.choice === "tarifa_plana") this.price = value.valores.valor;
      if (this.choice === "precio_ciudad") {
        this.priceCities = [];
        value.valores.rangos.map((rango) =>
          this.priceCities.push({ ...rango })
        );
        if (this.priceCities[this.priceCities.length - 1].id !== 0) {
          let obj = { ...this.cityDefault };
          this.priceCities.push(obj);
        }
      }
      this.loaderShipping = false;
    },
    sendRangosByPrice(params) {
      this.priceCities.forEach((element) => {
        if (element.deliveryTime == null || element.deliveryTime == "") {
          this.$message.error(
            "Debes ingresar el tiempo de entrega, verificar campos"
          );
          this.camposvacios = true;
          this.loaderShipping = true;
          return;
        } else {
          this.loaderShipping = false;
          params.rangos = { rangos: this.priceCities };
        }
      });
    },
    updateShipping() {
      this.loaderShipping = true;
      this.camposvacios = false;
      let idCiudades = [];
      let params = {
        metodo: { envio_metodo: this.choice },
        pais: 1,
        estado: 1,
        rangos: { valor: 0 },
      };
      switch (this.choice) {
        case "tarifa_plana":
          params.rangos = { valor: this.price };
          break;
        case "precio":
          params.rangos = { rangos: this.priceRanges };
          break;
        case "precio_ciudad": {
          let hasCityDefault = false;
          this.priceCities.forEach((item) =>
            item.id == 0 ? (hasCityDefault = true) : (hasCityDefault = false)
          );
          if (!hasCityDefault) {
            this.priceCities.push(this.cityDefault);
            hasCityDefault = false;
          }
          this.sendRangosByPrice(params);
          break;
        }
      }
      // console.log(params)
      if (
        params?.rangos?.rangos?.length &&
        params?.metodo?.envio_metodo !== "precio"
      ) {
        params.rangos.rangos.forEach((item) => idCiudades.push(item.id));
      }
      const esPrimero = (valor, indice, lista) =>
        lista.indexOf(valor) === indice;

      if (idCiudades.every(esPrimero)) {
        if (!this.camposvacios) {
          axios
            .post(
              `${this.$configKomercia.url}/api/admin/envios`,
              params,
              this.$store.state.configAxios
            )
            .then(() => {
              this.loaderShipping = false;
              this.$message.success(
                "Información de envios nacionales guardada correctamente"
              );
            });
        }
        if (this.updateShippingPolicies) {
          axios.post(
            `${this.$configKomercia.url}/api/admin/politicas/envios`,
            { envios: this.shippingPolicies },
            this.$store.state.configAxios
          );
        }
      } else {
        this.loaderShipping = false;
        this.$message.error("No debes tener ciudades repetidas");
      }
      this.camposvacios = true;
    },
    getDeliveryContent(choice) {
      return this.deliveryContent[choice];
    },
    addPriceRange() {
      let ifDoesntExist = { inicial: 0, final: 0, precio: 0 };
      let lastRange =
        this.priceRanges.slice(this.priceRanges.length - 1)[0] || ifDoesntExist;
      this.priceRanges.push({
        inicial: lastRange.final + 1,
        final: lastRange.final + 2,
        precio: 0,
      });
    },
    deletePriceRange(index) {
      this.priceRanges.splice(index, 1);
    },
    deletePriceCity(index /*city*/) {
      // this.removeZonasByCity(city.id)
      this.priceCities.splice(index, 1);
    },
    addWeightRange() {
      let ifDoesntExist = { inicial: 0, final: 0, precio: 0 };
      let lastRange =
        this.weightRanges.slice(this.weightRanges.length - 1)[0] ||
        ifDoesntExist;
      this.weightRanges.push({ inicial: lastRange.final, final: 0, precio: 0 });
    },
    deleteWeightRange(index) {
      this.weightRanges.splice(index, 1);
    },
    next() {
      this.toggleSwipper = true;
      this.swiper.slideNext(1000, false);
    },
    prev() {
      this.toggleSwipper = false;
      this.swiper.slidePrev(1000, false);
    },
    eliminarRestoDelPais() {
      // this.restoDelPais = false
      this.priceCities.splice(this.priceCities.length - 1, 1, {
        deliveryTime: "7 días",
        id: 0,
        price: -1,
      });
    },
    habilitarRestoDelPais() {
      // this.restoDelPais = true
      this.priceCities.splice(this.priceCities.length - 1, 1, {
        deliveryTime: "3-7 días",
        id: 0,
        price: 0,
      });
    },
    showDialog(city) {
      this.city = city;
      this.setDialogVisible(true);
      this.getZonas(city.id);
    },
    setDialogVisible(value) {
      this.dialogVisible = value;
    },
    getZonas(id = 1) {
      axios
        .get(
          `${this.$store.state.urlKomercia}/api/admin/zonas/city/${id}?page=1`,
          this.$store.state.configAxios
        )
        .then((response) => {
          this.zonas = response.data.zonas.data;
        });
    },
    removeZonasByCity(id) {
      axios
        .delete(
          `${this.$store.state.urlKomercia}/api/admin/zonas/eliminar/ciudad/${id}`,
          this.$store.state.configAxios
        )
        .catch((error) => console.error(error));
    },
  },
};
</script>

<style scoped>
.wrapper-nota {
  text-align: start;
  max-width: 1150px;
  min-width: 400px;
  width: 100%;
  font-size: 14px !important;
  color: var(--yellow);
}
.text-option {
  font-size: 12px;
  color: rgb(68, 68, 68);
}
.btn-radio {
  @apply w-6 h-6 cursor-pointer rounded-full border-2 flex justify-center items-center border-purple-700;
}
.btn-intRadio {
  @apply w-3 h-3 rounded-full border bg-green-400;
}
.btn-radio:hover .btn-intRadio {
  width: 14px;
  height: 14px;
}
input {
  @apply bg-transparent;
}
.cls-1 {
  fill: none;
  stroke: #fcc700;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.cls-2 {
  fill: #531fa9;
}
.free-envio:focus .cls-2 {
  fill: #fff;
}
.el-select {
  @apply bg-transparent;
}
.darktxt {
  color: #fff;
}
.lighttxt {
  @apply text-gray-800;
}
.lighttxt2 {
  color: #919191;
}
.darktxttitle {
  color: #fff;
}
.lighttxttitle {
  color: #4429b4;
}
.darktxtswiper {
  color: #33c9ad;
}
.lighttxtswiper {
  color: #4429b4;
}
.darktxtswiper {
  color: #33c9ad;
}
.lighttxtswiper {
  color: #4429b4;
}
.darkswitch {
  background-color: transparent;
}
.lightswitch {
  background-color: #fff;
}
.shipping__national {
  display: grid;
}
.shipping__national >>> .el-loading-mask {
  background-color: rgba(0, 0, 0, 0);
}
.el-radio-group {
  width: 100%;
  /* margin: 0px 15px; */
  display: flex;
  justify-content: center;
}
.el-radio-group >>> .el-radio-button__inner {
  @apply border rounded-md shadow-md;
}
.el-radio-button__inner {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 50px;
}
.el-radio-button__inner img {
  /* max-width: 115px; */
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin: 10px;
}
.delivery_content {
  max-width: 1035px;
  width: 100%;
  padding: 30px;
  border-radius: 5px;
  border: 1px solid #d8dce5;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
}
.centered {
  display: flex;
  justify-content: center;
  align-items: center;
}
.column {
  flex-direction: column;
}
.grid {
  display: grid;
  grid-template-columns: 1.5fr 1.5fr 1fr 60px;
  grid-gap: 10px;
}
.grid-cities {
  /* display: grid;
  grid-template-columns: 1.5fr 1fr 0.8fr 0.8fr 60px; */
  /* grid-gap: 10px; */
  @apply w-full grid grid-cols-4 gap-2;
}
.grid-bont {
  display: grid;
  grid-template-columns: 0.1fr 1.5fr 1fr 130px;
  grid-gap: 20px;
  @apply justify-center items-center border-2 border-purple-700 rounded-md mt-4 p-5;
}
.range {
  align-items: flex-end;
}
.text-new {
  font-size: 10px;
}
.text-info {
  font-size: 12px;
  font-weight: 500;
}
.input-area {
  width: 100%;
  max-height: 80px;
}
.input-idTienda {
  padding: 12px 11px;
  border-radius: 10px;
  background-color: #f2efff;
  font-size: 13px;
  max-height: 40px;
}
.inputs-idTienda >>> .el-input__inner {
  padding: 0px 15px;
  font-size: 13px;
  border-radius: 10px;
  border: solid 2px #f3f4f6;
  background-color: transparent;
  transition: none;
  max-height: 40px;
}
.darks-input >>> .el-input__inner {
  color: #f3f4f6;
}
.light-input >>> .el-input__inner {
  color: #1f2937;
}
.money-idTienda >>> [type="text"],
[type="email"],
[type="url"],
[type="password"],
[type="number"],
[type="date"],
[type="datetime-local"],
[type="month"],
[type="search"],
[type="tel"],
[type="time"],
[type="week"],
[multiple],
textarea,
select {
  padding: 5px 15px;
  font-size: 13px;
  border-radius: 10px;
  border: solid 2px #f3f4f6;
  background-color: transparent;
  transition: none;
  max-height: 40px;
}
.darks-money >>> [type="text"],
[type="email"],
[type="url"],
[type="password"],
[type="number"],
[type="date"],
[type="datetime-local"],
[type="month"],
[type="search"],
[type="tel"],
[type="time"],
[type="week"],
[multiple],
textarea,
select {
  color: #f3f4f6;
}
.light-money >>> [type="text"],
[type="email"],
[type="url"],
[type="password"],
[type="number"],
[type="date"],
[type="datetime-local"],
[type="month"],
[type="search"],
[type="tel"],
[type="time"],
[type="week"],
[multiple],
textarea,
select {
  color: #1f2937;
}
.range .el-button {
  margin-bottom: 5px;
}
.range .el-button + .el-button {
  margin-left: 0;
}
.range .el-button ~ .el-button {
  margin-right: 0;
}
.shadow {
  transition: filter ease 0.3s;
  filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.437));
}
.title {
  margin-bottom: 15px;
}
.description {
  line-height: 1.6;
  margin-bottom: 15px;
}
.shipping-title {
  font-size: 24px;
  /* font-weight: bold; */
  /* color: rgb(26, 46, 59); */
  /* font-size: 1.125rem; */
  /* font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; */
  font-weight: 900;
  letter-spacing: 0.01rem;
  margin-bottom: 5px;
}
.shipping__national > p:nth-child(2) {
  font-size: 16px;
  font-weight: 600;
  /* color: rgb(26, 46, 59); */
  /* font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; */
  font-weight: 500;
  letter-spacing: 0.01rem;
}

.row {
  max-width: 839px;
  margin: 0 auto;
  width: 100%;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.editor {
  max-width: 710px;
  width: 100%;
  margin: 0 auto;
  text-align: left;
  display: flex;
  justify-content: flex-start;
}
.wrapper-ranges {
  display: flex;
  flex-direction: column;
}
.policy-title {
  font-size: 18px;
  margin-bottom: 5px;
}
.policy-description {
  line-height: 1.4;
  margin-bottom: 20px;
}
.policies {
  cursor: pointer;
  /* color: #4429b4; */
  transition: all ease 0.3s;
  font-size: 16px;
  font-weight: 900;
  /* font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; */
  /* font-weight: 500; */
  letter-spacing: 0.01rem;
}
.policies:hover {
  @apply transform translate-x-2 transition;
}
.methods {
  font-size: 16px;
  font-weight: 900;
  cursor: pointer;
  color: #4429b4;
  transition: all ease 0.3s;
}
.methods:hover {
  @apply transform -translate-x-2 transition;
}
.wrapper-buttons {
  max-width: 839px;
  width: 100%;
  margin: 20px auto 0;
}
span i {
  font-size: 17px;
  vertical-align: -1.5px;
}
.wrapper-ranges-ciudad .el-button--text {
  margin: 0;
  margin-top: 10px;
}
.el-icon-question {
  height: initial;
}
.el-input__icon {
  /* display: flex; */
  align-items: center;
}
.wrapper-scroll-cities {
  max-height: 355px;
  overflow-y: auto;
}
.wrapper-scroll-cities::-webkit-scrollbar {
  -webkit-appearance: none;
}
.wrapper-scroll-cities::-webkit-scrollbar:vertical {
  width: 11px;
}
.wrapper-scroll-cities::-webkit-scrollbar-button:increment,
.wrapper-scroll-cities::-webkit-scrollbar-button {
  display: none;
}
.wrapper-scroll-cities::-webkit-scrollbar:horizontal {
  height: 10px;
}
.wrapper-scroll-cities::-webkit-scrollbar-thumb {
  background-color: #797979;
  border-radius: 20px;
  border: 1px solid #797979;
}
</style>
